import React, { useRef, useEffect, useState, useContext } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { FilterContext } from './context.jsx';

export const CategoryButton = ({ categoryKey, enabled }) => {
  const { t, i18n } = useTranslation();
  const { toggleFilter } = useContext(FilterContext);
  const capitalizedCategoryKey =
    categoryKey[0] + categoryKey.slice(1).toLowerCase();

  return (
    <button
      onClick={() => toggleFilter(`CATEGORY_${categoryKey}`)}
      className={enabled ? styles.CategoryBtnActive : ''}
    >
      <img
        src={`../img/products/category/condition-thumb-${capitalizedCategoryKey}${
          capitalizedCategoryKey === 'Weight' && i18n.resolvedLanguage !== 'EN'
            ? '-kg'
            : ''
        }.svg`}
        alt={t(`dashboard_Filter_CATEGORY_${categoryKey}`)}
      />
      <p>{t(`dashboard_ShopByCategory_CATEGORY_${categoryKey}`)}</p>
    </button>
  );
};

export const ShopByCategory = () => {
  const { t } = useTranslation();
  const { filters } = useContext(FilterContext);
  const categoryRowRef = useRef(null);
  const [showScrollSuggestion, setShowScrollSuggestion] = useState(true);

  useEffect(() => {
    function checkScrollEnd() {
      const el = categoryRowRef.current;
      if (el) {
        const hasScrolled = el.scrollLeft;
        setShowScrollSuggestion(!hasScrolled);
      }
    }

    const el = categoryRowRef.current;

    if (el) {
      el.addEventListener('scroll', checkScrollEnd);
      // Run once to initialize
      checkScrollEnd();
    }

    return () => {
      if (el) {
        el.removeEventListener('scroll', checkScrollEnd);
      }
    };
  }, [categoryRowRef]);

  return (
    <section className={styles.ShopByCategory} ref={categoryRowRef}>
      <h1>{t('dashboard_ShopByCategory_Text')}</h1>
      <div className={styles.CategoryRow}>
        {Object.entries(filters)
          .filter(([key, _]) => key.startsWith('CATEGORY_'))
          .map(([categoryKey, categoryObj]) => (
            <CategoryButton
              key={`shop-by-category-${categoryKey}`}
              categoryKey={categoryKey.split('CATEGORY_')[1]}
              enabled={categoryObj.enabled}
            />
          ))}
        {showScrollSuggestion && (
          <div className={styles.MobileScrollSuggestion}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.30005 7.54844L9.70005 6.14844L15.7 12.1484L9.70005 18.1484L8.30005 16.7484L12.9 12.1484L8.30005 7.54844Z"
                fill="#66676B"
              />
            </svg>
          </div>
        )}
      </div>
    </section>
  );
};
